import View from './View.js';

class AddRecipeView extends View {
  // upload is the parent element
  _parentElement = document.querySelector('.upload');
  _message = 'Recipe was successfully uploaded.';

  _window = document.querySelector('.add-recipe-window');
  _overlay = document.querySelector('.overlay');
  _btnOpen = document.querySelector('.nav__btn--add-recipe');
  _btnClose = document.querySelector('.btn--close-modal');

  // it's a child class, so call super.  _addHandlerShowWindow.  The _ means it is protected.  The controller doesn't interfere.  But we still have to import this object, so put it in controller.js
  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerHideWindow();
  }

  toggleWindow() {
    this._overlay.classList.toggle('hidden');
    this._window.classList.toggle('hidden');
  }

  _addHandlerShowWindow() {
    // take the overlay and remove hidden class (or toggle between open and closed).  This makes it reusable.  It's not necessary to put this in the controller, so build a constructor method.
    // manually setting to "this" will point to the current object
    this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
  }

  _addHandlerHideWindow() {
    this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
    this._overlay.addEventListener('click', this.toggleWindow.bind(this));
  }

  addHandlerUpload(handler) {
    // listen for the upload form event on the parent element
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      // how do we get access to all of the values?  FormData (a browser API).  Into the FormData constructor, pass in an element that is a form (which is the "this" keyword.)  Because we're in a handler function, so "this" will point to this._parentElement (the upload form).  This returns an object that we have to use the spread operator on (spread it into an array).  This array will contain all of the fields with all of the values in there.
      const dataArray = [...new FormData(this)];
      // what's the goal of the data?  We'll want to upload it to the API.  The uploading is an API call which occur in the model.  So we need to put this data into a model.  So create a controller function that'll handle this event.  Call it controlAddRecipe that will receive the new recipe data.

      // this will convert entries into an object.  This will take an array of entries and convert it.
      const data = Object.fromEntries(dataArray);
      // call the handler function
      handler(data);
    });
  }

  _generateMarkup() {}
}

export default new AddRecipeView();
